import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React, { ChangeEvent, FunctionComponent } from 'react';

import Texto from '@infotrack/presentacion-componentes/texto';

import IDocumento from 'Infotrack@Modelos/negocioRefactor/entidades/repositorio/IDocumento';
import IProveedores from 'Infotrack@Modelos/smartStock/proveedores/entidades/proveedores';

interface ICampoProveedorIdProps {
    deshabilitado: boolean;
    manejarCambioCampo: (nombreCampo: keyof IDocumento, nuevoValor: IDocumento[keyof IDocumento]) => any;
    proveedores: IProveedores[];
    valor?: number;
}

const CampoProveedorId: FunctionComponent<ICampoProveedorIdProps> = ({
    deshabilitado,
    manejarCambioCampo,
    proveedores,
    valor,
}) => (
    <Autocomplete
        disabled={deshabilitado}
        getOptionLabel={(p) => p.DescripcionProveedor}
        onChange={(_: ChangeEvent<{}>, proveedor: IProveedores | null) =>
            manejarCambioCampo('ProveedorId', proveedor ? proveedor.ProveedorId! : 0)
        }
        options={proveedores}
        renderInput={(params) => (
            <TextField
                {...params}
                fullWidth
                label={<Texto id="FormularioDocumento.CampoProveedorId.Nombre" />}
                required
            />
        )}
        value={proveedores.find((p) => p.ProveedorId === valor) || null}
        id={`CampoProveedor-${valor}`}
    />
);

export default CampoProveedorId;
